import { humanStatus } from "@shared/labels.ts";

export function StatusChip({ status }: { status: string }) {
  const kind = status === "cancelled" ? "needs" : status === "booked" || status.startsWith("booked") ? "booked" : "provisional";
  return <span className={`status-chip ${kind}`}>{humanStatus(status)}</span>;
}
